import { useCallback } from 'react';

export const usePageScroll = () => {
	const scrollToTop = useCallback(() => {
		window.scrollTo({ top: 0, behavior: 'smooth' });
	}, []);

	const scrollToElement = useCallback(
		(elementId: string) => {
			const element = document.getElementById(elementId);
			if (element) {
				element.scrollIntoView({ behavior: 'smooth', block: 'start' });
			} else {
				scrollToTop();
			}
		},
		[scrollToTop]
	);

	return { scrollToTop, scrollToElement };
};
